import {SchoolPersonnelModelV1} from 'resources/GeneratedModels/SchoolPersonnel/SchoolPersonnelModel.v1';

const SCHOOL_ADMIN_ROLES = [
  'school_administrator',
  'teacher_administrator',
  'district_administrator',
  'district_administrator_teacher'
];

const TEACHER_ROLES = ['teacher', 'teacher_administrator', 'district_administrator_teacher'];

type Extensions = ThisType<SchoolPersonnelModelV1>;

const extensions: Extensions = {
  isSchoolAdministrator(): boolean {
    return SCHOOL_ADMIN_ROLES.includes(this.getRole().getName());
  },

  isTeacher(): boolean {
    return TEACHER_ROLES.includes(this.getRole().getName());
  }
};

export default extensions;
